<GlobalNav backPath="/" />

<div class="section is-fullheight">
  <div class="container">
    <div class="column is-8-desktop is-10-tablet">
      <div class="box mt-5 content">
        <h1>Allgemeine Geschäftsbedingungen</h1>
        <ol>
          <li>Geltungsbereich</li>
          <li>Vertragsschluss</li>
          <li>Widerrufsrecht</li>
          <li>Preise und Zahlungsbedingungen</li>
          <li>Liefer- und Versandbedingungen</li>
          <li>Einr&auml;umung von Nutzungsrechten f&uuml;r digitale Inhalte</li>
          <li>
            Einr&auml;umung von Nutzungsrechten f&uuml;r Lizenzschl&uuml;ssel
          </li>
          <li>
            Vertragsdauer und Vertragsbeendigung bei Abonnementvertr&auml;gen
          </li>
          <li>Eigentumsvorbehalt</li>
          <li>M&auml;ngelhaftung (Gew&auml;hrleistung)</li>
          <li>
            Besondere Bedingungen f&uuml;r die Verarbeitung von Waren nach
            bestimmten Vorgaben des Kunden
          </li>
          <li>Anwendbares Recht</li>
          <li>Alternative Streitbeilegung</li>
        </ol>

        <h2>1) Geltungsbereich</h2>

        <p>
          <b>1.1</b>&thinsp;Diese Allgemeinen Gesch&auml;ftsbedingungen
          (nachfolgend &quot;AGB&quot;) der BE/GOLF. GbR (nachfolgend
          &quot;Verk&auml;ufer&quot;), gelten f&uuml;r alle Vertr&auml;ge
          &uuml;ber die Lieferung von Waren, die ein Verbraucher oder
          Unternehmer (nachfolgend &bdquo;Kunde&ldquo;) mit dem Verk&auml;ufer
          hinsichtlich der vom Verk&auml;ufer in seinem Online-Shop
          dargestellten Waren abschlie&szlig;t. Hiermit wird der Einbeziehung
          von eigenen Bedingungen des Kunden widersprochen, es sei denn, es ist
          etwas anderes vereinbart.
        </p>

        <p>
          <b>1.2</b>&thinsp;F&uuml;r Vertr&auml;ge &uuml;ber die Lieferung
          digitaler Inhalte gelten diese AGB entsprechend, sofern insoweit nicht
          ausdr&uuml;cklich etwas Abweichendes geregelt ist.
        </p>

        <p>
          <b>1.3</b>&thinsp;F&uuml;r Vertr&auml;ge &uuml;ber die Lieferung von
          Lizenzschl&uuml;sseln gelten diese AGB entsprechend, sofern insoweit
          nicht ausdr&uuml;cklich etwas Abweichendes geregelt ist. Dabei
          schuldet der Verk&auml;ufer die &Uuml;berlassung eines
          Lizenzschl&uuml;ssels zur Nutzung der von ihm beschriebenen Software
          bzw. Inhalte sowie die Einr&auml;umung der vertraglich vereinbarten
          Rechte zur Nutzung der jeweiligen Software bzw. Inhalte. Der Kunde
          erwirbt kein geistiges Eigentum an der Software bzw. an den Inhalten.
          F&uuml;r die Beschaffenheit der Software bzw. Inhalte ist die
          jeweilige Produktbeschreibung im Online-Shop des Verk&auml;ufers
          ma&szlig;geblich.
        </p>

        <p>
          <b>1.4</b>&thinsp;Verbraucher im Sinne dieser AGB ist jede
          nat&uuml;rliche Person, die ein Rechtsgesch&auml;ft zu Zwecken
          abschlie&szlig;t, die &uuml;berwiegend weder ihrer gewerblichen noch
          ihrer selbst&auml;ndigen beruflichen T&auml;tigkeit zugerechnet werden
          k&ouml;nnen. Unternehmer im Sinne dieser AGB ist eine nat&uuml;rliche
          oder juristische Person oder eine rechtsf&auml;hige
          Personengesellschaft, die bei Abschluss eines Rechtsgesch&auml;fts in
          Aus&uuml;bung ihrer gewerblichen oder selbst&auml;ndigen beruflichen
          T&auml;tigkeit handelt.
        </p>

        <p>
          <b>1.5</b>&thinsp;Digitale Inhalte im Sinne dieser AGB sind alle nicht
          auf einem k&ouml;rperlichen Datentr&auml;ger befindlichen Daten, die
          in digitaler Form hergestellt und vom Verk&auml;ufer unter
          Einr&auml;umung bestimmter in diesen AGB genauer geregelten
          Nutzungsrechte, bereitgestellt werden.
        </p>

        <p>
          <b>1.6</b>&thinsp;Gegenstand des Vertrages kann &ndash; je nach
          Produktbeschreibung des Verk&auml;ufers - sowohl der Bezug von Waren
          im Wege einer Einmallieferung als auch der Bezug von Waren im Wege
          einer dauerhaften Lieferung (nachfolgend
          &bdquo;Abonnementvertrag&ldquo;) sein. Beim Abonnementvertrag
          verpflichtet sich der Verk&auml;ufer, dem Kunden die vertraglich
          geschuldete Ware f&uuml;r die Dauer der vereinbarten Vertragslaufzeit
          in den vertraglich geschuldeten Zeitintervallen zu liefern.
        </p>

        <h2>2) Vertragsschluss</h2>

        <p>
          <b>2.1</b>&thinsp;Die im Online-Shop des Verk&auml;ufers enthaltenen
          Produktbeschreibungen stellen keine verbindlichen Angebote seitens des
          Verk&auml;ufers dar, sondern dienen zur Abgabe eines verbindlichen
          Angebots durch den Kunden.
        </p>

        <p>
          <b>2.2</b>&thinsp;Der Kunde kann das Angebot &uuml;ber das in den
          Online-Shop des Verk&auml;ufers integrierte Online-Bestellformular
          abgeben. Dabei gibt der Kunde, nachdem er die ausgew&auml;hlten Waren
          in den virtuellen Warenkorb gelegt und den elektronischen
          Bestellprozess durchlaufen hat, durch Klicken des den Bestellvorgang
          abschlie&szlig;enden Buttons ein rechtlich verbindliches
          Vertragsangebot in Bezug auf die im Warenkorb enthaltenen Waren ab.
        </p>

        <p>
          <b>2.3</b>&thinsp;Der Verk&auml;ufer kann das Angebot des Kunden
          innerhalb von f&uuml;nf Tagen annehmen,
        </p>

        <ul>
          <li>
            indem er dem Kunden eine schriftliche Auftragsbest&auml;tigung oder
            eine Auftragsbest&auml;tigung in Textform (Fax oder E-Mail)
            &uuml;bermittelt, wobei insoweit der Zugang der
            Auftragsbest&auml;tigung beim Kunden ma&szlig;geblich ist, oder
          </li>
          <li>
            indem er dem Kunden die bestellte Ware liefert, wobei insoweit der
            Zugang der Ware beim Kunden ma&szlig;geblich ist, oder
          </li>
          <li>
            indem er den Kunden nach Abgabe von dessen Bestellung zur Zahlung
            auffordert.
          </li>
        </ul>

        <p>
          Liegen mehrere der vorgenannten Alternativen vor, kommt der Vertrag in
          dem Zeitpunkt zustande, in dem eine der vorgenannten Alternativen
          zuerst eintritt. Die Frist zur Annahme des Angebots beginnt am Tag
          nach der Absendung des Angebots durch den Kunden zu laufen und endet
          mit dem Ablauf des f&uuml;nften Tages, welcher auf die Absendung des
          Angebots folgt. Nimmt der Verk&auml;ufer das Angebot des Kunden
          innerhalb vorgenannter Frist nicht an, so gilt dies als Ablehnung des
          Angebots mit der Folge, dass der Kunde nicht mehr an seine
          Willenserkl&auml;rung gebunden ist.
        </p>

        <p>
          <b>2.4</b>&thinsp;Bei Auswahl einer von PayPal angebotenen Zahlungsart
          erfolgt die Zahlungsabwicklung &uuml;ber den Zahlungsdienstleister
          PayPal (Europe) S.&agrave; r.l. et Cie, S.C.A., 22-24 Boulevard Royal,
          L-2449 Luxembourg (im Folgenden: &bdquo;PayPal&ldquo;), unter Geltung
          der PayPal-Nutzungsbedingungen, einsehbar unter
          https://www.paypal.com/de/webapps/mpp/ua/useragreement-full oder -
          falls der Kunde nicht &uuml;ber ein PayPal-Konto verf&uuml;gt &ndash;
          unter Geltung der Bedingungen f&uuml;r Zahlungen ohne PayPal-Konto,
          einsehbar unter
          https://www.paypal.com/de/webapps/mpp/ua/privacywax-full. Zahlt der
          Kunde mittels einer im Online-Bestellvorgang ausw&auml;hlbaren von
          PayPal angebotenen Zahlungsart, erkl&auml;rt der Verk&auml;ufer schon
          jetzt die Annahme des Angebots des Kunden in dem Zeitpunkt, in dem der
          Kunde den den Bestellvorgang abschlie&szlig;enden Button anklickt.
        </p>

        <p>
          <b>2.5</b>&thinsp;Bei der Abgabe eines Angebots &uuml;ber das
          Online-Bestellformular des Verk&auml;ufers wird der Vertragstext nach
          dem Vertragsschluss vom Verk&auml;ufer gespeichert und dem Kunden nach
          Absendung von dessen Bestellung in Textform (z. B. E-Mail, Fax oder
          Brief) &uuml;bermittelt. Eine dar&uuml;ber hinausgehende
          Zug&auml;nglichmachung des Vertragstextes durch den Verk&auml;ufer
          erfolgt nicht. Sofern der Kunde vor Absendung seiner Bestellung ein
          Nutzerkonto im Online-Shop des Verk&auml;ufers eingerichtet hat,
          werden die Bestelldaten auf der Website des Verk&auml;ufers archiviert
          und k&ouml;nnen vom Kunden &uuml;ber dessen passwortgesch&uuml;tztes
          Nutzerkonto unter Angabe der entsprechenden Login-Daten kostenlos
          abgerufen werden.
        </p>

        <p>
          <b>2.6</b>&thinsp;Vor verbindlicher Abgabe der Bestellung &uuml;ber
          das Online-Bestellformular des Verk&auml;ufers kann der Kunde
          m&ouml;gliche Eingabefehler durch aufmerksames Lesen der auf dem
          Bildschirm dargestellten Informationen erkennen. Ein wirksames
          technisches Mittel zur besseren Erkennung von Eingabefehlern kann
          dabei die Vergr&ouml;&szlig;erungsfunktion des Browsers sein, mit
          deren Hilfe die Darstellung auf dem Bildschirm vergr&ouml;&szlig;ert
          wird. Seine Eingaben kann der Kunde im Rahmen des elektronischen
          Bestellprozesses so lange &uuml;ber die &uuml;blichen Tastatur- und
          Mausfunktionen korrigieren, bis er den den Bestellvorgang
          abschlie&szlig;enden Button anklickt.
        </p>

        <p>
          <b>2.7</b>&thinsp;F&uuml;r den Vertragsschluss steht
          ausschlie&szlig;lich die deutsche Sprache zur Verf&uuml;gung.
        </p>

        <p>
          <b>2.8</b>&thinsp;Die Bestellabwicklung und Kontaktaufnahme finden in
          der Regel per E-Mail und automatisierter Bestellabwicklung statt. Der
          Kunde hat sicherzustellen, dass die von ihm zur Bestellabwicklung
          angegebene E-Mail-Adresse zutreffend ist, so dass unter dieser Adresse
          die vom Verk&auml;ufer versandten E-Mails empfangen werden
          k&ouml;nnen. Insbesondere hat der Kunde bei dem Einsatz von
          SPAM-Filtern sicherzustellen, dass alle vom Verk&auml;ufer oder von
          diesem mit der Bestellabwicklung beauftragten Dritten versandten
          E-Mails zugestellt werden k&ouml;nnen.
        </p>

        <h2>3) Widerrufsrecht</h2>

        <p>
          <b>3.1</b>&thinsp;Verbrauchern steht grunds&auml;tzlich ein
          Widerrufsrecht zu.
        </p>

        <p>
          <b>3.2</b>&thinsp;N&auml;here Informationen zum Widerrufsrecht ergeben
          sich aus der Widerrufsbelehrung des Verk&auml;ufers.
        </p>

        <h2>4) Preise und Zahlungsbedingungen</h2>

        <p>
          <b>4.1</b>&thinsp;Sofern sich aus der Produktbeschreibung des
          Verk&auml;ufers nichts anderes ergibt, handelt es sich bei den
          angegebenen Preisen um Gesamtpreise, die die gesetzliche Umsatzsteuer
          enthalten. Gegebenenfalls zus&auml;tzlich anfallende Liefer- und
          Versandkosten werden in der jeweiligen Produktbeschreibung gesondert
          angegeben.
        </p>

        <p>
          <b>4.2</b>&thinsp;Die Zahlungsm&ouml;glichkeit/en wird/werden dem
          Kunden im Online-Shop des Verk&auml;ufers mitgeteilt.
        </p>

        <p>
          <b>4.3</b>&thinsp;Bei Auswahl der Zahlungsart &bdquo;SOFORT&ldquo;
          erfolgt die Zahlungsabwicklung &uuml;ber den Zahlungsdienstleister
          SOFORT GmbH, Theresienh&ouml;he 12, 80339 M&uuml;nchen (im Folgenden
          &bdquo;SOFORT&ldquo;). Um den Rechnungsbetrag &uuml;ber
          &bdquo;SOFORT&ldquo; bezahlen zu k&ouml;nnen, muss der Kunde &uuml;ber
          ein f&uuml;r die Teilnahme an &bdquo;SOFORT&ldquo; frei geschaltetes
          Online-Banking-Konto verf&uuml;gen, sich beim Zahlungsvorgang
          entsprechend legitimieren und die Zahlungsanweisung gegen&uuml;ber
          &bdquo;SOFORT&ldquo; best&auml;tigen. Die Zahlungstransaktion wird
          unmittelbar danach von &bdquo;SOFORT&ldquo; durchgef&uuml;hrt und das
          Bankkonto des Kunden belastet. N&auml;here Informationen zur
          Zahlungsart &bdquo;SOFORT&ldquo; kann der Kunde im Internet unter
          https://www.klarna.com/sofort/ abrufen.
        </p>

        <p>
          <b>4.4</b>&thinsp;Bei Auswahl der Zahlungsart Rechnungskauf wird der
          Kaufpreis f&auml;llig, nachdem die Ware geliefert und in Rechnung
          gestellt wurde. In diesem Fall ist der Kaufpreis innerhalb von 7
          (sieben) Tagen ab Erhalt der Rechnung ohne Abzug zu zahlen, sofern
          nichts anderes vereinbart ist. Der Verk&auml;ufer beh&auml;lt sich
          vor, die Zahlungsart Rechnungskauf nur bis zu einem bestimmten
          Bestellvolumen anzubieten und diese Zahlungsart bei
          &Uuml;berschreitung des angegebenen Bestellvolumens abzulehnen. In
          diesem Fall wird der Verk&auml;ufer den Kunden in seinen
          Zahlungsinformationen im Online-Shop auf eine entsprechende
          Zahlungsbeschr&auml;nkung hinweisen.
        </p>

        <p>
          <b>4.5</b>&thinsp;Bei Auswahl der Zahlungsart Rechnungskauf wird der
          Kaufpreis f&auml;llig, nachdem die Ware geliefert und in Rechnung
          gestellt wurde. In diesem Fall ist der Kaufpreis innerhalb von 14
          (vierzehn) Tagen ab Erhalt der Rechnung ohne Abzug zu zahlen, sofern
          nichts anderes vereinbart ist. Der Verk&auml;ufer beh&auml;lt sich
          vor, die Zahlungsart Rechnungskauf nur bis zu einem bestimmten
          Bestellvolumen anzubieten und diese Zahlungsart bei
          &Uuml;berschreitung des angegebenen Bestellvolumens abzulehnen. In
          diesem Fall wird der Verk&auml;ufer den Kunden in seinen
          Zahlungsinformationen im Online-Shop auf eine entsprechende
          Zahlungsbeschr&auml;nkung hinweisen. Der Verk&auml;ufer beh&auml;lt
          sich ferner vor, bei Auswahl der Zahlungsart Rechnungskauf eine
          Bonit&auml;tspr&uuml;fung durchzuf&uuml;hren und diese Zahlungsart bei
          negativer Bonit&auml;tspr&uuml;fung abzulehnen.
        </p>

        <p>
          <b>4.6</b>&thinsp;Bei Auswahl der Zahlungsart &bdquo;PayPal
          Rechnung&ldquo; tritt der Verk&auml;ufer seine Zahlungsforderung an
          PayPal ab. Vor Annahme der Abtretungserkl&auml;rung des
          Verk&auml;ufers f&uuml;hrt PayPal unter Verwendung der
          &uuml;bermittelten Kundendaten eine Bonit&auml;tspr&uuml;fung durch.
          Der Verk&auml;ufer beh&auml;lt sich vor, dem Kunden die Zahlungsart
          &bdquo;PayPal Rechnung&ldquo; im Falle eines negativen
          Pr&uuml;fungsergebnisses zu verweigern. Wird die Zahlungsart
          &bdquo;PayPal Rechnung&ldquo; von PayPal zugelassen, hat der Kunde den
          Rechnungsbetrag innerhalb von 30 Tagen ab Erhalt der Ware an PayPal zu
          bezahlen, sofern ihm von PayPal kein anderes Zahlungsziel vorgegeben
          wird. Er kann in diesem Fall nur an PayPal mit schuldbefreiender
          Wirkung leisten. Der Verk&auml;ufer bleibt jedoch auch im Falle der
          Forderungsabtretung zust&auml;ndig f&uuml;r allgemeine Kundenanfragen
          z. B. zur Ware, Lieferzeit, Versendung, Retouren, Reklamationen,
          Widerrufserkl&auml;rungen und -zusendungen oder Gutschriften.
          Erg&auml;nzend gelten die Allgemeinen Nutzungsbedingungen f&uuml;r die
          Nutzung des Rechnungskaufs von PayPal, einsehbar unter
          https://www.paypal.com/de/webapps/mpp/ua/pui-terms.
        </p>

        <p>
          <b>4.7</b>&thinsp;Bei Auswahl der Zahlungsart SEPA-Lastschrift ist der
          Rechnungsbetrag nach Erteilung eines SEPA-Lastschriftmandats, nicht
          jedoch vor Ablauf der Frist f&uuml;r die Vorabinformation zur Zahlung
          f&auml;llig. Der Einzug der Lastschrift erfolgt, wenn die bestellte
          Ware das Lager des Verk&auml;ufers verl&auml;sst, nicht jedoch vor
          Ablauf der Frist f&uuml;r die Vorabinformation. Vorabinformation
          (&quot;Pre-Notification&quot;) ist jede Mitteilung (z.B. Rechnung,
          Police, Vertrag) des Verk&auml;ufers an den Kunden, die eine Belastung
          mittels SEPA-Lastschrift ank&uuml;ndigt. Wird die Lastschrift mangels
          ausreichender Kontodeckung oder aufgrund der Angabe einer falschen
          Bankverbindung nicht eingel&ouml;st oder widerspricht der Kunde der
          Abbuchung, obwohl er hierzu nicht berechtigt ist, hat der Kunde die
          durch die R&uuml;ckbuchung des jeweiligen Kreditinstituts entstehenden
          Geb&uuml;hren zu tragen, wenn er dies zu vertreten hat.
        </p>

        <h2>5) Liefer- und Versandbedingungen</h2>

        <p>
          <b>5.1</b>&thinsp;Die Lieferung von Waren erfolgt auf dem Versandweg
          an die vom Kunden angegebene Lieferanschrift, sofern nichts anderes
          vereinbart ist. Bei der Abwicklung der Transaktion ist die in der
          Bestellabwicklung des Verk&auml;ufers angegebene Lieferanschrift
          ma&szlig;geblich. Abweichend hiervon ist bei Auswahl der Zahlungsart
          PayPal die vom Kunden zum Zeitpunkt der Bezahlung bei PayPal
          hinterlegte Lieferanschrift ma&szlig;geblich.
        </p>

        <p>
          <b>5.2</b>&thinsp;Scheitert die Zustellung der Ware aus Gr&uuml;nden,
          die der Kunde zu vertreten hat, tr&auml;gt der Kunde die dem
          Verk&auml;ufer hierdurch entstehenden angemessenen Kosten. Dies gilt
          im Hinblick auf die Kosten f&uuml;r die Hinsendung nicht, wenn der
          Kunde sein Widerrufsrecht wirksam aus&uuml;bt. F&uuml;r die
          R&uuml;cksendekosten gilt bei wirksamer Aus&uuml;bung des
          Widerrufsrechts durch den Kunden die in der Widerrufsbelehrung des
          Verk&auml;ufers hierzu getroffene Regelung.
        </p>

        <p>
          <b>5.3</b>&thinsp;Selbstabholung ist aus logistischen Gr&uuml;nden
          nicht m&ouml;glich.
        </p>

        <p>
          <b>5.4</b>&thinsp;Digitale Inhalte werden dem Kunden
          ausschlie&szlig;lich in elektronischer Form wie folgt &uuml;berlassen:
        </p>

        <ul>
          <li>per Download</li>
          <li>per E-Mail</li>
        </ul>

        <p>
          <b>5.5</b>&thinsp;Lizenzschl&uuml;ssel werden dem Kunden wie folgt
          &uuml;berlassen:
        </p>

        <ul>
          <li>per Download</li>
          <li>per E-Mail</li>
        </ul>

        <h2>
          6) Einr&auml;umung von Nutzungsrechten f&uuml;r digitale Inhalte
        </h2>

        <p>
          <b>6.1</b>&thinsp;Sofern sich aus der Inhaltsbeschreibung im
          Online-Shop des Verk&auml;ufers nichts anderes ergibt, r&auml;umt der
          Verk&auml;ufer dem Kunden an den &uuml;berlassenen Inhalten das nicht
          ausschlie&szlig;liche, &ouml;rtlich und zeitlich unbeschr&auml;nkte
          Recht ein, die &uuml;berlassenen Inhalte zu privaten sowie zu
          gesch&auml;ftlichen Zwecken zu nutzen.
        </p>

        <p>
          <b>6.2</b>&thinsp;Eine Weitergabe der Inhalte an Dritte oder die
          Erstellung von Kopien f&uuml;r Dritte au&szlig;erhalb des Rahmens
          dieser AGB ist nicht gestattet, soweit nicht der Verk&auml;ufer einer
          &Uuml;bertragung der vertragsgegenst&auml;ndlichen Lizenz an den
          Dritten zugestimmt hat.
        </p>

        <p>
          <b>6.3</b>&thinsp;Die Rechtseinr&auml;umung wird erst wirksam, wenn
          der Kunde die vertraglich geschuldete Verg&uuml;tung vollst&auml;ndig
          geleistet hat. Der Verk&auml;ufer kann eine Benutzung der
          vertragsgegenst&auml;ndlichen Inhalte auch schon vor diesem Zeitpunkt
          vorl&auml;ufig erlauben. Ein &Uuml;bergang der Rechte findet durch
          eine solche vorl&auml;ufige Erlaubnis nicht statt.
        </p>

        <h2>
          7) Einr&auml;umung von Nutzungsrechten f&uuml;r Lizenzschl&uuml;ssel
        </h2>

        <p>
          <b>7.1</b>&thinsp;Der &uuml;berlassene Lizenzschl&uuml;ssel berechtigt
          den Kunden zur Nutzung der aus der jeweiligen Produktbeschreibung
          ersichtlichen Software bzw. Inhalte in dem dort beschriebenen Umfang.
        </p>

        <p>
          <b>7.2</b>&thinsp;Die Rechtseinr&auml;umung wird erst wirksam, wenn
          der Kunde die geschuldete Verg&uuml;tung vollst&auml;ndig geleistet
          hat.
        </p>

        <h2>
          8) Vertragsdauer und Vertragsbeendigung bei Abonnementvertr&auml;gen
        </h2>

        <p>
          <b>8.1</b>&thinsp;Abonnementvertr&auml;ge werden befristet, f&uuml;r
          die aus der jeweiligen Produktbeschreibung im Online-Shop des
          Verk&auml;ufers ersichtliche Vertragslaufzeit geschlossen und enden
          automatisch nach Ablauf der Vertragslaufzeit.
        </p>

        <p>
          <b>8.2</b>&thinsp;Das Recht zur au&szlig;erordentlichen K&uuml;ndigung
          aus wichtigem Grund bleibt unber&uuml;hrt. Ein wichtiger Grund liegt
          vor, wenn dem k&uuml;ndigenden Teil unter Ber&uuml;cksichtigung aller
          Umst&auml;nde des Einzelfalls und unter Abw&auml;gung der
          beiderseitigen Interessen die Fortsetzung des
          Vertragsverh&auml;ltnisses bis zur vereinbarten Beendigung oder bis
          zum Ablauf einer K&uuml;ndigungsfrist nicht zugemutet werden kann.
        </p>

        <p>
          <b>8.3</b>&thinsp;K&uuml;ndigungen haben schriftlich oder in Textform
          (z. B. per E-Mail) zu erfolgen.
        </p>

        <h2>9) Eigentumsvorbehalt</h2>

        <p>
          Tritt der Verk&auml;ufer in Vorleistung, beh&auml;lt er sich bis zur
          vollst&auml;ndigen Bezahlung des geschuldeten Kaufpreises das Eigentum
          an der gelieferten Ware vor.
        </p>

        <h2>10) M&auml;ngelhaftung (Gew&auml;hrleistung)</h2>

        <p>
          <b>10.1</b>&thinsp;Ist die Kaufsache mangelhaft, gelten die
          Vorschriften der gesetzlichen M&auml;ngelhaftung.
        </p>

        <p>
          <b>10.2</b>&thinsp;Handelt der Kunde als Verbraucher, so wird er
          gebeten, angelieferte Waren mit offensichtlichen Transportsch&auml;den
          bei dem Zusteller zu reklamieren und den Verk&auml;ufer hiervon in
          Kenntnis zu setzen. Kommt der Kunde dem nicht nach, hat dies keinerlei
          Auswirkungen auf seine gesetzlichen oder vertraglichen
          M&auml;ngelanspr&uuml;che.
        </p>

        <h2>
          11) Besondere Bedingungen f&uuml;r die Verarbeitung von Waren nach
          bestimmten Vorgaben des Kunden
        </h2>

        <p>
          <b>11.1</b>&thinsp;Schuldet der Verk&auml;ufer nach dem Inhalt des
          Vertrages neben der Warenlieferung auch die Verarbeitung der Ware nach
          bestimmten Vorgaben des Kunden, hat der Kunde dem Verk&auml;ufer alle
          f&uuml;r die Verarbeitung erforderlichen Inhalte wie Texte, Bilder
          oder Grafiken in den vom Verk&auml;ufer vorgegebenen Dateiformaten,
          Formatierungen, Bild- und Dateigr&ouml;&szlig;en zur Verf&uuml;gung zu
          stellen und ihm die hierf&uuml;r erforderlichen Nutzungsrechte
          einzur&auml;umen. F&uuml;r die Beschaffung und den Rechteerwerb an
          diesen Inhalten ist allein der Kunde verantwortlich. Der Kunde
          erkl&auml;rt und &uuml;bernimmt die Verantwortung daf&uuml;r, dass er
          das Recht besitzt, die dem Verk&auml;ufer &uuml;berlassenen Inhalte zu
          nutzen. Er tr&auml;gt insbesondere daf&uuml;r Sorge, dass hierdurch
          keine Rechte Dritter verletzt werden, insbesondere Urheber-, Marken-
          und Pers&ouml;nlichkeitsrechte.
        </p>

        <p>
          <b>11.2</b>&thinsp;Der Kunde stellt den Verk&auml;ufer von
          Anspr&uuml;chen Dritter frei, die diese im Zusammenhang mit einer
          Verletzung ihrer Rechte durch die vertragsgem&auml;&szlig;e Nutzung
          der Inhalte des Kunden durch den Verk&auml;ufer diesem gegen&uuml;ber
          geltend machen k&ouml;nnen. Der Kunde &uuml;bernimmt hierbei auch die
          angemessenen Kosten der notwendigen Rechtsverteidigung
          einschlie&szlig;lich aller Gerichts- und Anwaltskosten in gesetzlicher
          H&ouml;he. Dies gilt nicht, wenn die Rechtsverletzung vom Kunden nicht
          zu vertreten ist. Der Kunde ist verpflichtet, dem Verk&auml;ufer im
          Falle einer Inanspruchnahme durch Dritte unverz&uuml;glich,
          wahrheitsgem&auml;&szlig; und vollst&auml;ndig alle Informationen zur
          Verf&uuml;gung zu stellen, die f&uuml;r die Pr&uuml;fung der
          Anspr&uuml;che und eine Verteidigung erforderlich sind.
        </p>

        <p>
          <b>11.3</b>&thinsp;Der Verk&auml;ufer beh&auml;lt sich vor,
          Verarbeitungsauftr&auml;ge abzulehnen, wenn die vom Kunden
          hierf&uuml;r &uuml;berlassenen Inhalte gegen gesetzliche oder
          beh&ouml;rdliche Verbote oder gegen die guten Sitten versto&szlig;en.
          Dies gilt insbesondere bei &Uuml;berlassung verfassungsfeindlicher,
          rassistischer, fremdenfeindlicher, diskriminierender, beleidigender,
          Jugend gef&auml;hrdender und/oder Gewalt verherrlichender Inhalte.
        </p>

        <h2>12) Anwendbares Recht</h2>

        <p>
          F&uuml;r s&auml;mtliche Rechtsbeziehungen der Parteien gilt das Recht
          der Bundesrepublik Deutschland unter Ausschluss der Gesetze &uuml;ber
          den internationalen Kauf beweglicher Waren. Bei Verbrauchern gilt
          diese Rechtswahl nur insoweit, als nicht der gew&auml;hrte Schutz
          durch zwingende Bestimmungen des Rechts des Staates, in dem der
          Verbraucher seinen gew&ouml;hnlichen Aufenthalt hat, entzogen wird.
        </p>

        <h2>13) Alternative Streitbeilegung</h2>

        <p>
          <b>13.1</b>&thinsp;Die EU-Kommission stellt im Internet unter
          folgendem Link eine Plattform zur Online-Streitbeilegung bereit:
          https://ec.europa.eu/consumers/odr
        </p>

        <p>
          Diese Plattform dient als Anlaufstelle zur au&szlig;ergerichtlichen
          Beilegung von Streitigkeiten aus Online-Kauf- oder
          Dienstleistungsvertr&auml;gen, an denen ein Verbraucher beteiligt ist.
        </p>

        <p>
          <b>13.2</b>&thinsp;Der Verk&auml;ufer ist zur Teilnahme an einem
          Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
          weder verpflichtet noch bereit.
        </p>
      </div>
      <a class="button is-outlined" on:click="{() => history.back()}">Zurück</a>
    </div>
  </div>
</div>

<script>
import GlobalNav from "./GlobalNav.svelte";
import Heading from "./Heading.svelte";
</script>
